<script setup>
import FloatingInputFK from '#common/components/FloatingInputFK.vue'
import { Loader } from '@googlemaps/js-api-loader'

const emit = defineEmits(['onAddressSelected'])
const googleAutocomplete = ref(undefined)
const attrs = useAttrs()
const metadata = useMetadata()

function mountOnFocus() {
  const elementId = attrs.id
  const loader = new Loader({
    apiKey: metadata.settingsVars.GOOGLE_MAPS_API_KEY,
    version: 'weekly',
  })
  loader
    .importLibrary('places')
    .then(({ Autocomplete }) => {
      googleAutocomplete.value = new Autocomplete(
        document.getElementById(elementId),
        {
          types: ['address'],
          componentRestrictions: { country: 'us' },
        },
      )
      googleAutocomplete.value.addListener('place_changed', () => {
        const place = googleAutocomplete.value.getPlace()
        if (place?.address_components) {
          emit('onAddressSelected', {
            place: {
              ...place,
              parts: _.mapKeys(
                place.address_components,
                (v) => v.types.filter((c) => c !== 'political')[0],
              ),
            },
          })
        }
      })
    })
    .catch((e) => {
      console.log('there was an error loading Google Maps APIs', e)
    })
}
</script>

<template>
  <FloatingInputFK
    v-bind="attrs"
    data-1p-ignore="true"
    data-lpignore="true"
    @focus="mountOnFocus"
  />
</template>
